export default {
  data() {
    return {
      windowWidth: null,
      windowHeight: null,
      isMobile: false
    }
  },
  created() {
    this.setEvents();
    this.handleWindowResize();
  },
  methods: {
    setEvents() {
      window.addEventListener('resize', this.handleWindowResize.bind(this));
    },
    handleWindowResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      this.isMobile = this.windowWidth < 768;
    }
  }
}